module.exports = __webpack_public_path__ + "static/media/logoutIcon.f78933fc.svg";